@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
    style="margin: auto"
  ></mat-progress-spinner>
}

@if (!loading()) {
  <form [formGroup]="formGroup">
    @if (isDuplicated) {
      <div class="duplicate-warning">
        <b>Figyelem!</b>
        Ez a hitelező duplikált (azonos adószámú másik hitelező is létezik).
      </div>
    }
    @if (formGroup.value.company_updated_at) {
      <span class="company-updated-at">
        <span>Utolsó frissítés:</span>
        <span>
          {{ formGroup.value.company_updated_at | date: "yyyy.MM.dd. HH:mm" }}
        </span>
      </span>
    }
    <h2>Alap adatok</h2>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="name"
        [matAutocomplete]="clientAuto"
        (input)="onCompanySearchInput($event)"
      />
      <span payee-label>Név</span>
      <mat-autocomplete
        #clientAuto="matAutocomplete"
        [requireSelection]="false"
        (optionSelected)="companySelected($event)"
      >
        @for (option of autocompleteOptions; track option.tax_number || option.name) {
          <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </payee-form-field>
    <payee-form-field width="wide">
      <span payee-label>Hitelező típusa</span>
      <payee-autocomplete
        placeholder="Válassz típust!"
        [formControl]="party_type_id"
        [options]="partyTypeOptions"
        [displayWith]="partyTypeDisplayWith"
        [clearable]="true"
        [requireSelection]="false"
      ></payee-autocomplete>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="tax_number"
      />
      <span payee-label>Adószám</span>
    </payee-form-field>
    <app-bank-account-form [form]="bank_account"></app-bank-account-form>
    <app-address-form
      [countries]="countries"
      [form]="address"
    ></app-address-form>
    @if (!isOrg()) {
      <h2>Személyes adatok</h2>
      <payee-form-field width="wide">
        <payee-datepicker [formControl]="birth_date"></payee-datepicker>
        <span payee-label>Születési idő</span>
      </payee-form-field>
      <payee-form-field width="wide">
        <input
          payee-input
          [formControl]="birth_place"
        />
        <span payee-label>Születési hely</span>
      </payee-form-field>
      <payee-form-field width="wide">
        <input
          payee-input
          [formControl]="mother_name"
        />
        <span payee-label>Anyja születési neve</span>
      </payee-form-field>
    }
    @if (!isHouse()) {
      <payee-form-field width="wide">
        <input
          payee-input
          [formControl]="registration_number"
        />
        <span payee-label>Nyilvántartási szám</span>
      </payee-form-field>
    }
    @if (isOrg()) {
      <div class="flex vcenter top-margin-15">
        <h2>Képviselők</h2>
        @if (!formGroup.value.lock_representatives) {
          <button
            payee-icon-button
            color="white"
            [isBorderButton]="true"
            (click)="lockRepresentatives()"
          >
            <payee-icon name="pencil"></payee-icon>
          </button>
        }
        @if (formGroup.value.lock_representatives) {
          <button
            payee-icon-button
            color="white"
            [isBorderButton]="true"
            (click)="unlockRepresentatives()"
          >
            <payee-icon name="lock-grey"></payee-icon>
          </button>
        }
      </div>
      <app-representatives-form
        [representatives]="$any(formGroup.get('representatives'))"
        [representativeTypes]="representativeTypes"
        [countries]="countries"
      ></app-representatives-form>
    }
  </form>
}
